/* eslint-disable no-console */
import { ActionType } from './common-action-type';
import { isTestEnvId, isLocalDebug } from '@src/js/common/utils';
import i18n from '@i18next/i18n';
import { TitleBarConfig, TitlebarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { DefaultActions } from '@framework/editor/src/js/constants';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import {
    fontGroup,
    paragraphGroup,
    effectGroup,
    arrange,
    ToolListType,
    underline,
    deleteline,
    subscript,
    superscript,
    backColor,
} from './toolbar-data';
import { SYNC_DESCRIPTION } from '@src/slide/application/service/sync-file/core/constants';
import { TAILOR_PIC_NORMAL_WITHOUT_ICON } from '@src/framework/workbench/schema/top-menu';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import {
    AlignType,
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

const disableItemFontGroup = fontGroup.map((item) => {
    const simpleItem = {
        id: item.id,
    };
    return simpleItem;
});

const disableItemParagraphGroup = paragraphGroup.map((item) => {
    const simpleItem = {
        id: item.id,
    };
    return simpleItem;
});
const doubleParagraphGroup = [
    { id: IndentType.INDENT_INCREASE },
    { id: IndentType.INDENT_REDUCE },
    { id: AlignType.HORIZONTAL_LEFT },
    { id: AlignType.HORIZONTAL_CENTER },
    { id: AlignType.HORIZONTAL_RIGHT },
    { id: AlignType.HORIZONTAL_JUSTIFY },
    { id: AlignType.HORIZONTAL_DISTRIBUTE },
];
const dropdownParagraphGroup = [
    { id: AlignType.VERTICAL_TOP },
    { id: AlignType.VERTICAL_CENTER },
    { id: AlignType.VERTICAL_BOTTOM },
    { id: ActionType.COLUMNS },
];

disableItemParagraphGroup.push(...doubleParagraphGroup, ...dropdownParagraphGroup);

// 排列-全部图层在未选中元素时常亮
const getDisableItemEffectGroup = () => {
    const index = effectGroup.findIndex(item => item.id === ActionType.MOVE_ITEM);
    const disableItems = effectGroup.slice(0, index).concat(effectGroup.slice(index + 1));
    const { data } = arrange.dropdown!;
    const selectWindowIndex = data!.findIndex(item => item.id === ActionType.SELECT_WINDOW);
    const arrangeDisableItems = data!.slice(0, selectWindowIndex).concat(data!.slice(selectWindowIndex + 1));
    return disableItems.concat(arrangeDisableItems as ToolListType[]).map((item) => {
        const simpleItem = {
            id: item.id,
        };
        return simpleItem;
    });
};
const disableItemEffectGroup = getDisableItemEffectGroup();

export const getAccessibilityDescription = () => {
    let description = '';
    if (browser.isMac) {
        description = '⌃ + ~';
    } else if (browser.isWindows) {
        description = 'Ctrl + ~';
    }
    return description;
};

export const DIVIDER = {
    id: ActionType.DIVIDER,
};

// fileMenuXX - fileMenu 菜单组数据

const fileMenuDocInfo = [
    {
        id: DefaultActions.DOC_INFO,
    },
];

const fileMenuCopyLink = [
    {
        id: ActionType.COPY_DOC_LINK,
        title: i18n.t('复制链接'),
    },
];

const fileMenuExport = [
    {
        id: ActionType.EXPORT,
        title: i18n.t('导出为'),
        children: [
            { id: ActionType.NATIVE_PPT, title: i18n.t('本地PPT文档(.pptx)') },
            /**
             * unclick: 未被点击时显示红点，点击后去掉红点
             * expire: 红点过期日期，格式：yyyy-mm-dd
             * duration: 未点击经过时间段，红点消失，单位ms
             * related: 红点显示是否关联上下级
             */
            {
                id: ActionType.EXPORT_PDF,
                title: i18n.t('PDF文档'),
                badge: {
                    visible: {
                        duration: 604800000,
                        unclick: true,
                        expire: '2020-11-30',
                    },
                    related: true,
                },
            },
            { id: ActionType.GENERATE_SHORTCUT, title: i18n.t('生成本地快捷方式') },
        ],
    },
    {
        id: ActionType.IMPORT_SLIDE,
        title: i18n.t('导入到当前文档'),
        children: [
            { id: ActionType.IMPORT_LOCAL_SLIDE, title: i18n.t('从本地文档') },
            /* eslint-disable @tencent/i18next/no-literal-string */
            { id: ActionType.IMPORT_ONLINE_SLIDE, title: TENANT_CONFIG?.TENANT_DOC_NAME ? `从${TENANT_CONFIG?.TENANT_DOC_NAME}` : i18n.t('从腾讯文档') },
        ],
    },
    {
        id: ActionType.GENERATE_COPIES,
        title: i18n.t('生成副本'),
    },
    {
        id: ActionType.SAVE_TEMP,
        title: i18n.t('另存为我的模板'),
    },
];

const fileMenuRecord = [
    {
        id: ActionType.REVISION_RECORD,
        title: i18n.t('修订记录'),
    },
    {
        id: ActionType.BROWSE_RECORD,
        title: i18n.t('浏览记录'),
    },
];

const fileMenuPermission = [
    {
        id: ActionType.PERMISSION_MENU,
        title: i18n.t('权限设置'),
        children: [
            {
                id: ActionType.PERMISSION_SETTING,
                title: i18n.t('文档权限'),
            },
            {
                id: ActionType.ADVANCED_PERMISSION,
                title: i18n.t('高级权限'),
            },
            {
                id: ActionType.SET_WATER_MARK,
                title: i18n.t('设置文档水印'),
            },
            DIVIDER,
            {
                id: ActionType.TRANSFER_OWNERSHIP,
                title: i18n.t('转让文档所有权'),
            },
        ],
    },
];

const fileMenuHelp = [
    {
        id: ActionType.ACCESSIBILITY,
        title: i18n.t('开启无障碍读屏'),
        description: getAccessibilityDescription(),
    },
    {
        id: ActionType.HELP_FEEDBACK,
        title: i18n.t('帮助与反馈'),
        children: [
            {
                id: ActionType.HELP,
                title: i18n.t('帮助中心'),
            },
            {
                id: ActionType.REPORT,
                title: i18n.t('反馈'),
            },
            {
                id: ActionType.ACCUSATION,
                title: i18n.t('举报'),
            },
            {
                id: ActionType.PRIVACY,
                title: i18n.t('隐私'),
                children: [
                    {
                        id: ActionType.PRIVACY_POLICY,
                        title: i18n.t('隐私政策'),
                    },
                    {
                        id: ActionType.THIRD_PARTY_DATA_SHARING,
                        title: i18n.t('第三方共享信息清单'),
                    },
                    {
                        id: ActionType.THIRD_AUTHORIZATION_MANAGEMENT,
                        title: i18n.t('第三方应用授权管理'),
                    },
                    {
                        id: ActionType.PERSONAL_INFO_COLLECTION,
                        title: i18n.t('个人信息收集清单'),
                    },
                ],
            },
            {
                id: ActionType.INFRINGEMENT,
                title: i18n.t('侵权指引'),
            },
            {
                id: ActionType.APPEAL,
                title: i18n.t('受限文档申诉'),
            },
            {
                id: ActionType.ABOUT,
                title: i18n.t('功能介绍'),
            },
        ],
    },
    {
        id: ActionType.SYNC_TO_LIST,
        title: i18n.t('同步到企业微信文档列表'),
        children: [
            {
                id: ActionType.SYNC_DESC,
                title: i18n.t('同步后，将支持快捷管理'),
                style: {
                    paddingLeft: 16,
                    opacity: 0.4,
                    cursor: 'default',
                },
            },
            {
                id: ActionType.NOT_SYNC,
                title: i18n.t(SYNC_DESCRIPTION.NOT),
            },
            {
                id: ActionType.SYNC_CURRENT_FILE,
                title: i18n.t(SYNC_DESCRIPTION.CURRENT),
            },
            {
                id: ActionType.SYNC_ALL_FILE,
                title: i18n.t(SYNC_DESCRIPTION.ALL),
            },
        ],
    },
];

// 开发者选项
const fileMenuDevTool = [
    {
        id: ActionType.DIVIDER,  // 分割线，所有分割线，都是这个ID
    },
    {
        id: ActionType.DEVELOPMENT,
        title: i18n.t('开发者工具'),
        children: [
            { id: ActionType.PERFORMANCE, title: i18n.t('性能监控') },
        ],
    },
];

// 退出文档
const fileMenuExit = [
    {
        id: ActionType.EXIT_DOCUMENT,
        title: i18n.t('退出文档'),
    },
];

export const CollapseMenuData = [
    {
        id: ActionType.GROUP, // 组合/取消组合 一级入口
        title: i18n.t('组合'),
        children: [
            { id: ActionType.ADDGROUP, title: i18n.t('组合') },
            { id: ActionType.REMOVEGROUP, title: i18n.t('取消组合') },
        ],
    },
    {
        id: ActionType.ALIGN,
        title: i18n.t('对齐'),
        children: [
            { id: ActionType.ALIGN_HORIZONTALLT_LEFT, title: i18n.t('左对齐') },
            { id: ActionType.ALIGN_HORIZONTALLT_CENTER, title: i18n.t('居中') },
            { id: ActionType.ALIGN_HORIZONTALLT_RIGHT, title: i18n.t('右对齐') },
            { id: ActionType.DIVIDER },  // 分割线，所有分割线，都是这个ID
            { id: ActionType.ALIGN_VERTICALLY_TOP, title: i18n.t('顶部对齐') },
            { id: ActionType.ALIGN_VERTICALLY_CENTER, title: i18n.t('垂直居中') },
            { id: ActionType.ALIGN_VERTICALLY_BOTTOM, title: i18n.t('底部对齐') },
            { id: ActionType.DIVIDER },  // 分割线，所有分割线，都是这个ID
            { id: ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT, title: i18n.t('横向分散') },
            { id: ActionType.ALIGN_DISTRIBUTE_VERTICALLY, title: i18n.t('纵向分散') },
        ],
    },
    {
        id: ActionType.RANK,
        title: i18n.t('排列'),
        children: [
            { id: ActionType.MOVE_ITEM_UP, title: i18n.t('上移一层') },
            { id: ActionType.ROOT_UPPER, title: i18n.t('置顶') },
            { id: ActionType.MOVE_ITEM_DOWN, title: i18n.t('下移一层') },
            { id: ActionType.BASE_DOWN, title: i18n.t('置底') },
        ],
    },
    DIVIDER,
    {
        id: ActionType.TEXT_STYLE,
        title: i18n.t('文本格式'),
        children: [
            { id: ActionType.BOLD, title: i18n.t('粗体') },
            { id: ActionType.ITALIC, title: i18n.t('斜体') },
            { id: ActionType.UNDERLINE, title: i18n.t('下划线') },
            { id: ActionType.DELETELINE, title: i18n.t('删除线') },
            { id: ActionType.SUPERSCRIPT, title: i18n.t('上标') },
            { id: ActionType.SUBSCRIPT, title: i18n.t('下标') },
            // { id: ActionType.TEXT_SPACE,title: '文本间距' },
            { id: ActionType.FORECOLOR, title: i18n.t('字体颜色'), children: [{ id: ActionType.TEXT_COLOR_PALETTE, title: i18n.t('色板') }] },
            { id: ActionType.BACKCOLOR, title: i18n.t('字体突出显示'), children: [{ id: ActionType.TEXT_BG_PALETTE, title: i18n.t('色板') }] },
            { id: ActionType.TEXT_FORMAT, title: i18n.t('设置更多文本格式') },
        ],
    },
    {
        id: ActionType.TYPESET,
        title: i18n.t('段落格式'),
        children: [
            {
                id: ActionType.HORIZONTAL_ALIGN, title: i18n.t('水平对齐'),
                children: [
                    { id: ActionType.HORIZONTAL_ALIGN + 1, title: i18n.t('左对齐'), data: 'horizontal_left' },
                    { id: ActionType.HORIZONTAL_ALIGN + 2, title: i18n.t('居中对齐'), data: 'horizontal_center' },
                    { id: ActionType.HORIZONTAL_ALIGN + 3, title: i18n.t('右对齐'), data: 'horizontal_right' },
                    { id: ActionType.HORIZONTAL_ALIGN + 4, title: i18n.t('两端对齐'), data: 'horizontal_justify' },
                    { id: ActionType.HORIZONTAL_ALIGN + 5, title: i18n.t('分散对齐'), data: 'horizontal_distribute' },
                ],
            },
            {
                id: ActionType.VERTICAL_ALIGN, title: i18n.t('垂直对齐'),
                children: [
                    { id: ActionType.VERTICAL_ALIGN + 1, title: i18n.t('顶端对齐'), data: 'vertical_top' },
                    { id: ActionType.VERTICAL_ALIGN + 2, title: i18n.t('中部对齐'), data: 'vertical_center' },
                    { id: ActionType.VERTICAL_ALIGN + 3, title: i18n.t('底端对齐'), data: 'vertical_bottom' },
                ],
            },
            {
                id: ActionType.ROW_SPACE, title: i18n.t('行间距'),
                children: [
                    { id: ActionType.ROW_SPACE + 1, title: i18n.t('1倍行距'), data: 1 },
                    { id: ActionType.ROW_SPACE + 2, title: i18n.t('1.3倍行距'), data: 1.3 },
                    { id: ActionType.ROW_SPACE + 3, title: i18n.t('1.5倍行距'), data: 1.5 },
                    { id: ActionType.ROW_SPACE + 4, title: i18n.t('2倍行距'), data: 2 },
                    { id: ActionType.ROW_SPACE + 5, title: i18n.t('2.5倍行距'), data: 2.5 },
                    { id: ActionType.ROW_SPACE + 6, title: i18n.t('3倍行距'), data: 3 },
                ],
            },
            // { id: ActionType.INDENT, title: '缩进' },
            { id: ActionType.PARAGRAPH_MORE, title: i18n.t('自定义行间距') },
        ],
    },
    {
        id: ActionType.TABLE_DETAIL,
        title: i18n.t('表格格式'),
        children: [
            // { id: ActionType.BORDER_LINE, title: '边框线' },
            // { id: ActionType.COLOR_FILL, title: '填充颜色' },
            // { id: ActionType.MERGE_CELL, title: '合并、取消合并单元格' },
            // { id: ActionType.HORIZONTAL_ALIGN, title: '水平对齐' },
            // { id: ActionType.VERTICAL_ALIGN, title: '垂直对齐' },
            // { id: ActionType.CLEAR_FORMAT_SUB, title: '清除格式' },
            // { id: ActionType.AVERAGE_ROW, title: '均分行宽' },
            // { id: ActionType.AVERAGE_COL, title: '均分列宽' },

            { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色'), children: [{ id: ActionType.FILLCOLOR_PALETTE, title: i18n.t('色板') }] },
            { id: ActionType.BORDERCOLOR, title: i18n.t('边框颜色'), children: [{ id: ActionType.BORDERCOLOR_PALETTE, title: i18n.t('色板') }] },
            { id: ActionType.BORDERSTYLE, title: i18n.t('边框格式'), children: [{ id: ActionType.BORDERSTYLE + 1, title: i18n.t('自定义') }] },
            { id: ActionType.MERGE_CELL, title: i18n.t('合并单元格') },
        ],
    },
    {
        id: ActionType.FORMAT_PIC,
        title: i18n.t('图片格式'),
        children: [
            { id: ActionType.TAILOR_PIC_NORMAL, title: i18n.t('裁剪') },
            {
                id: ActionType.TAILOR_PIC_SHAPE, title: i18n.t('裁剪为形状'), children: [
                    { id: ActionType.TAILOR_PIC_SELECT_SHAPE, title: i18n.t('形状选择框') },
                ],
            },
            {
                id: ActionType.TAILOR_PIC_WH, title: i18n.t('裁剪为纵横比'),
                children: [
                    { id: ActionType.TAILOR_PIC_WH_1_1, title: '1:1' },
                    { id: ActionType.DIVIDER },
                    { id: ActionType.TAILOR_PIC_WH_2_3, title: '2:3' },
                    { id: ActionType.TAILOR_PIC_WH_3_4, title: '3:4' },
                    { id: ActionType.TAILOR_PIC_WH_3_5, title: '3:5' },
                    { id: ActionType.TAILOR_PIC_WH_4_5, title: '4:5' },
                    { id: ActionType.DIVIDER },
                    { id: ActionType.TAILOR_PIC_WH_3_2, title: '3:2' },
                    { id: ActionType.TAILOR_PIC_WH_4_3, title: '4:3' },
                    { id: ActionType.TAILOR_PIC_WH_5_3, title: '5:3' },
                    { id: ActionType.TAILOR_PIC_WH_5_4, title: '5:4' },
                    { id: ActionType.TAILOR_PIC_WH_16_9, title: '16:9' },
                    { id: ActionType.TAILOR_PIC_WH_16_10, title: '16:10' },
                ],
            },
            {
                id: ActionType.PIC_FORMAT,
                title: i18n.t('设置图片格式'),
            },
            // { id: ActionType.RESET_PIC, title: '重置（还原）' },
        ],
    },
    {
        id: ActionType.SHAPE_FORMAT,
        title: i18n.t('形状格式'),
    },
    DIVIDER,
    {
        id: ActionType.INSERT_ANIMATION,
        title: i18n.t('动画'),
    },
    DIVIDER,
    {
        id: ActionType.SLIDE_SIZE,
        title: i18n.t('页面设置'),
        children: [
            { id: ActionType.SLIDE_STANDARD, title: i18n.t('标准（4：3）') },
            { id: ActionType.SLIDE_WIDE, title: i18n.t('宽屏（16：9）') },
            { id: ActionType.SLIDE_CUSTOM, title: i18n.t('自定义') },
            // { id: ActionType.SLIDE_HEADER_FOOTER, title: '页眉和页脚' },
        ],
    },
    {
        id: ActionType.WATERMARK,
        title: i18n.t('设置水印'),
    },
    DIVIDER,
    {
        id: ActionType.SEARCH_REPLACE,
        title: i18n.t('查找与替换'),
        shortcut: 'Cmd+F',
    },
];

// Menu Bar 顶部菜单栏
export const MenuBarData = [
    setDefaultConfig(appConfigInstance.getConfig(TitleBarConfig.collapseMenu as any), true) ? {
        id: 'collapse-menu',
        title: i18n.t('编辑功能'),
        menuList: getCollapseMenuData(),
    } : null,
].filter(item => item);

// 通过这个方法返回编辑菜单数据
function getCollapseMenuData() {
    if (config.supportEnterprise(EnterPriseType.ALL)) {
        const waterMarkIndex = CollapseMenuData.findIndex(data => data.id === ActionType.WATERMARK);
        if (waterMarkIndex > -1) {
            CollapseMenuData.splice(waterMarkIndex, 1);
        }
    }
    return CollapseMenuData;
}

// 通过这个方法返回menu菜单数据
export function getPCTopMenuBarData() {
    if (!(appConfigInstance.getConfig(TitleBarConfig.fileMenu as any) ?? true)) return [null];

    // 精简模式, 当前只在会议场景使用
    // - 隐藏 导入、导出、生成副本，权限，帮助 等入口
    // - 新增 复制链接
    // 详情见 【腾讯文档】【文档 X 会议】合作规划图表 https://docs.qq.com/sheet/DTUdWWG1jeU5BQ1pY
    const isSimplifyMode = (appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false);
    const isDev = isLocalDebug() || isTestEnvId();

    const menuGroups = [
        fileMenuDocInfo,
        isSimplifyMode && fileMenuCopyLink,
        !isSimplifyMode && fileMenuExport,
        fileMenuRecord,
        fileMenuPermission,
        !isSimplifyMode && fileMenuHelp,
        isDev && fileMenuDevTool,
        fileMenuExit,
    ];

    const menuList = (menuGroups.filter(group => Array.isArray(group)) as Array<{ id: string }>[])
        .reduce((resList, menuGroup) => {
            const group = menuGroup.filter(item => !!item);
            if (group.length === 0) return resList;

            if (resList.length > 0) resList.push(DIVIDER);
            return resList.concat(group);
        }, []);

    return [{
        id: 'file-menu',
        title: i18n.t('文档操作'),
        menuList,
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        btnBgImg: require('../../img/menu/menu_file.svg'),
        buttonStyle: {
            margin: '0',
        },
    }];
}


function pushMenuItem(items, allItems) {
    items.forEach((item) => {
        allItems.push({ id: item.id, title: item.title });
        if (item.children) {
            pushMenuItem(item.children, allItems);
        }
    });
}

let allMenuItems;
/**
 * 获取全量的top菜单项
 * @returns {Array}
 */
export function getAllMenuItems() {
    if (allMenuItems) {
        return allMenuItems;
    }
    let items: any = [];
    MenuBarData.forEach((item) => {
        items = item?.menuList ? items.concat(item.menuList) : items;
    });
    const allItems = [];

    pushMenuItem(items, allItems);
    allMenuItems = allItems;
    return allItems;
}


// ---------------------------------disable的菜单项-----------------------------------------

// 未选中元素时，不可用菜单项
export const NoneSelectDisableItems: ToolListType[] = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    ...disableItemEffectGroup,
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.CLEAR_FORMAT, title: i18n.t('清除格式') },
    { id: ActionType.RANK, title: i18n.t('排列') },
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.SHAPE_FORMAT, title: i18n.t('设置形状格式') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.BORDER_LINE_ITEM, title: i18n.t('形状和线条') },
    // { id: ActionType.NEW_SLIDE, title: '新建幻灯片' },
    // { id: ActionType.DELETE_SLIDE, title: '删除幻灯片' },
    // { id: ActionType.COPY_SLIDE, title: '复制幻灯片' },
    // { id: ActionType.MOVE_SLIDE, title: '移动幻灯片' },
    { id: ActionType.USE_LAYOUT, title: i18n.t('应用布局') },
    { id: ActionType.TRANSITION, title: i18n.t('过渡动画') },
    { id: ActionType.ALIGN, title: i18n.t('对齐') },
    { id: ActionType.TAILOR_PIC, title: i18n.t('裁剪') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('图片透明度') },
];

// 未选中元素时，不可用菜单项
export const SlideSelectDisableItems = ([
    // { id: ActionType.INSERT_ANIMATION, title: '动画' }, // 动画要一直显示
] as ToolListType[]).concat(NoneSelectDisableItems);

// 选中文本框时的不可用菜单项
export const TextBoxSelectDisableItems = [
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
];

// 选中文本时-非图片填充的不可用菜单项
export const TextSelectDisableItems = [
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
];

// 选中文本-图片填充-充满的不可用菜单项
export const TextImageFillSelectDisableItems = [
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
];

// 选中文本-图片填充-平铺的不可用菜单项
export const TextImageTileFillSelectDisableItems = [
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.TAILOR_PIC_NORMAL, title: i18n.t('裁剪') },
    { id: TAILOR_PIC_NORMAL_WITHOUT_ICON, title: i18n.t('裁剪') },
];

// 选中iframe或者media元素时的不可用菜单项
export const AttachSelectDisableItems = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('段落格式') },
    { id: ActionType.SHAPE_FORMAT, title: i18n.t('形状格式') },
    { id: ActionType.ENTER_EDITOR, title: i18n.t('编辑文字') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框设置') },
    { id: ActionType.TAILOR_PIC, title: i18n.t('裁剪') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('图片透明度') },
];

// 选中图片时的不可用菜单项
export const PicSelectDisableItems = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
];

// 选中图表时的不可用菜单项
export const ChartSelectDisableItems = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框设置') },
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.CLEAR_FORMAT, title: i18n.t('清除格式') },
];

// 选中图表进行富文本编辑时的不可用菜单项
export const ChartTextEditingDisableItems = [
    underline,
    deleteline,
    subscript,
    superscript,
    backColor,
    // office禁用了部分段落，这里先禁用所有段落设置
    ...disableItemParagraphGroup,
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框设置') },
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.CLEAR_FORMAT, title: i18n.t('清除格式') },
];

// 选中 SmartArt 时的不可用菜单项
export const SmartArtSelectDisableItems = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框设置') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('图片透明度') },
    { id: ActionType.BORDER_LINE_ITEM, title: i18n.t('形状和线条') },
    { id: ActionType.USE_LAYOUT, title: i18n.t('应用布局') },
    { id: ActionType.TRANSITION, title: i18n.t('过渡动画') },
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.CLEAR_FORMAT, title: i18n.t('清除格式') },
    { id: ActionType.TAILOR_PIC, title: i18n.t('裁剪') },
];

// 选中表格时的不可用菜单项
export const TableSelectDisableItems = [
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.LINK, title: i18n.t('链接') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.COLUMNS, title: i18n.t('分栏') },
];

// 选中图表时的不可用菜单项
export const ChatSelectDisableItems = [
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.PARAGRAPH_MORE, title: i18n.t('更多段落格式') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
    { id: ActionType.LINK, title: i18n.t('链接') },
];

// 选中图形时的不可用菜单项
export const ShapeSelectDisableItems = [
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.INDENT, title: i18n.t('缩进') },   // 有文字才可用,这个之后在菜单before show之前单独判断
];

// 选中线条时的不可用菜单项
export const LineSelectDisableItems = [
    ...disableItemFontGroup,
    ...disableItemParagraphGroup,
    { id: ActionType.LINK, title: i18n.t('链接') },
    { id: ActionType.TEXT_STYLE, title: i18n.t('文本格式') },
    { id: ActionType.TYPESET, title: i18n.t('对齐缩进') },
    { id: ActionType.SYMBOL_NUMBER, title: i18n.t('项目符号与编号') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.EDIT_TEXT, title: i18n.t('编辑文字') },
    { id: ActionType.NONE_FILL, title: i18n.t('形状填充-无填充') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('形状填充-透明度') },
    { id: ActionType.FILLCOLOR, title: i18n.t('形状填充-填充颜色') },
    { id: ActionType.NONE_BORDER, title: i18n.t('形状轮廓-无轮廓') },
];

// 多选/组合时的不可用菜单项
export const GroupSelectDisableItems = [
    { id: ActionType.LINK, title: i18n.t('链接') },
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.TAILOR_PIC_NORMAL, title: i18n.t('裁剪') },
    { id: TAILOR_PIC_NORMAL_WITHOUT_ICON, title: i18n.t('裁剪') },
    { id: ActionType.TAILOR_PIC_WH, title: i18n.t('裁剪为纵横比') },
    { id: ActionType.PIC_FORMAT, title: i18n.t('设置图片格式') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('图片透明度') },
];

export const NoteDisabledItems = [
    { id: ActionType.FORMAT_BRUSH, title: i18n.t('格式刷') },
    { id: ActionType.CLEAR_FORMAT, title: i18n.t('清除格式') },
    { id: ActionType.RANK, title: i18n.t('排列') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.SHAPE_FORMAT, title: i18n.t('设置形状格式') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.BORDER_LINE_ITEM, title: i18n.t('形状和线条') },
    { id: ActionType.USE_LAYOUT, title: i18n.t('应用布局') },
    { id: ActionType.TRANSITION, title: i18n.t('过渡动画') },
    { id: ActionType.GROUP, title: i18n.t('组合') },
    { id: ActionType.VERTICAL_ALIGN, title: i18n.t('垂直对齐') },
    { id: ActionType.ALIGN, title: i18n.t('对齐') },
    { id: ActionType.INSERT_TEXT, title: i18n.t('文本框') },
    { id: ActionType.INSERT_PICTURE, title: i18n.t('图片') },
    { id: ActionType.INSERT_FORM, title: i18n.t('表格') },
    { id: ActionType.INSERT_SHAPE, title: i18n.t('形状线条') },
    { id: ActionType.INSERT_SHAPE_PARENT, title: i18n.t('形状线条一级下拉菜单') },
    { id: ActionType.PARAGRAPH_MORE, title: i18n.t('更多段落格式') },
    { id: ActionType.EFFECT, title: i18n.t('效果设置') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充颜色') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框设置') },
    { id: ActionType.COLUMNS, title: i18n.t('分栏') },
];

//
export const SpeakerRemarkDisableItems = [
    { id: ActionType.PARAGRAPH_MORE, title: i18n.t('更多段落格式') },
    { id: ActionType.TABLE_DETAIL, title: i18n.t('表格') },
    { id: ActionType.FORMAT_PIC, title: i18n.t('图片') },
    { id: ActionType.NONE_FILL, title: i18n.t('形状填充-无填充') },
    { id: ActionType.TRANSPARENCY, title: i18n.t('形状填充-透明度') },
    { id: ActionType.FILLCOLOR, title: i18n.t('形状填充-填充颜色') },
    { id: ActionType.NONE_BORDER, title: i18n.t('形状轮廓-无轮廓') },
    { id: ActionType.BORDER_LINE_COLOR, title: i18n.t('形状轮廓-线条颜色') },
    { id: ActionType.BORDER_LINE_WIDTH, title: i18n.t('形状轮廓-线条粗细') },
    { id: ActionType.BORDER_LINE_STYLE, title: i18n.t('形状轮廓-线条样式') },
    { id: ActionType.BORDER_ARROW_STYLE, title: i18n.t('形状轮廓-箭头样式') },
    { id: ActionType.BORDER_GRADUAL_LINE, title: i18n.t('形状轮廓-渐变线') },
];


// 协同者disable的工具栏
export const CollaboratorSelectDisableItems = [
    // { id: ActionType.TRANSFER_OWNERSHIP, title: i18n.t('转让文档所有权') },
    { id: ActionType.PERMISSION_MENU, title: i18n.t('权限设置') },
    { id: ActionType.APPEAL, title: i18n.t('受限文档申诉') },
];

// 内存中没有复制粘贴的时候disable粘贴
export const NoPasteMemoryCacheDisableItems = [
    { id: ActionType.PASTE, title: i18n.t('粘贴') },
];

// 内存中没有undo
export const NoUndoDisableItems = [
    { id: ActionType.UNDO, title: i18n.t('撤销') },
];

// 内存中没有redo
export const NoRedoDisableItems = [
    { id: ActionType.REDO, title: i18n.t('重做') },
];

// 查看态时候禁用菜单项目
export const ViewerDisableItems = [
    { id: `${ActionType.EXPORT_PDF}-toolbar` },
];

// 查看态时候可用菜单项目
export const ViewerEnableItems = [
    ActionType.NEW,
    ActionType.ONLINE_DOC,
    ActionType.ONLINE_SHEET,
    ActionType.ONLINE_DEMO,
    ActionType.ONLINE_COLLECT,
    ActionType.OTHER_DOC,
    ActionType.ONLINE_MIND,
    ActionType.ONLINE_FLOWCHART,
    // ActionType.IMPORT_MENU,
    ActionType.IMPORT_DOC,
    // ActionType.NEW_FILE,
    ActionType.ONLINE_TEMPLATE,
    ActionType.GENERATE_SHORTCUT,
    ActionType.HELP_FEEDBACK,
    ActionType.REPORT,
    ActionType.HELP,
    ActionType.ABOUT,
    ActionType.ACCUSATION,
    ActionType.PRIVACY,
    ActionType.PRIVACY_POLICY,
    ActionType.THIRD_PARTY_DATA_SHARING,
    ActionType.PERSONAL_INFO_COLLECTION,
    ActionType.INFRINGEMENT,
    ActionType.RESTART_DEMO,
    ActionType.CUR_PAGE_DEMO,
    ActionType.FULL_SCREEN_MODEL,
    ActionType.REPLACE,
    ActionType.SEARCH,
    ActionType.SLIDE_PLAY,
    ActionType.SEARCH_REPLACE,
    ActionType.ACCESSIBILITY,
    ActionType.COPY_DOC_LINK,
    ActionType.PDF_TRANSFORM,
    ActionType.PDF_TO_WORD,
    ActionType.PDF_TO_EXCEL,
    ActionType.PDF_TO_PPT,
    ActionType.EXIT_DOCUMENT,
    ActionType.TOOLBAR_MODE,
    ActionType.INSERT_ALL,
    ActionType.INSERT_COMMENT,
];

// lock disable 锁定
export const LockDisableItems = [
    { id: ActionType.CUT, title: i18n.t('剪切') },
    { id: ActionType.SHAPE_FORMAT, title: i18n.t('设置形状格式') },
    { id: ActionType.INSERT_TEXT, title: i18n.t('文本框') },
    { id: ActionType.INSERT_PICTURE, title: i18n.t('图片') },
    { id: ActionType.INSERT_FORM, title: i18n.t('表格') },
    { id: ActionType.INSERT_SHAPE, title: i18n.t('形状线条') },
    { id: ActionType.CHANGE_BG, title: i18n.t('设置背景') },
    { id: ActionType.SEARCH_REPLACE, title: i18n.t('查找与替换') },
];

// 非文档所有者无权限
export const notOwnerDisableItems = [
    { id: ActionType.WATERMARK, title: i18n.t('设置水印') },
];

// 多选两个元素时，禁用横向分散与纵向分散
export const TwoElementDistributeDisableItems = [
    { id: ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT, title: i18n.t('横向分散') },
    { id: ActionType.ALIGN_DISTRIBUTE_VERTICALLY, title: i18n.t('纵向分散') },
];

// 批注相关按钮
export const CommentDisableItems = [
    ActionType.SHOW_COMMENT,
    ActionType.INSERT_COMMENT,
    ActionType.DELETE_COMMENT,
    ActionType.JUMP_TO_NEXT_COMMENT,
    ActionType.JUMP_TO_PREV_COMMENT,
    ActionType.SHOW_COMMENT_ANCHOR,
    ActionType.SHOW_COMMENT_NOTIFY_FLAG,
];
